import moment from "moment";

export const formatDateIfValid = (dateValue: any): string | null => {
    if (dateValue === null || dateValue === undefined || dateValue === "null") return null;

    const m =
        typeof dateValue === "string"
            ? moment(dateValue)
            : moment.unix(Number(dateValue));

    return m.isValid() ? m.format("LLL") : null;
};

export const checkIfEncrypted = (value: string | undefined): string => {
    if (!value) return "N/A";

    const isEncrypted =
        /^(?:[a-f0-9]{32}|[a-f0-9]{40}|[a-f0-9]{64}|[A-Za-z0-9+/=]{32,44})$/.test(
            value
        );

    return isEncrypted ? "Encrypted" : value;
};
